import { EpimsBaseEntityDto } from './epim-base.dto';
export class FunctionDto extends EpimsBaseEntityDto {
    FunctionName: string;
    CompanyId: string;
    SubscriptionUserId: string;  
    Version: number;
}